module.exports = __webpack_public_path__ + "static/media/hoppin5.f906cb9d.webp";